import { render } from "./ohotel.vue?vue&type=template&id=022d4e24&scoped=true"
const script = {}

import "./ohotel.vue?vue&type=style&index=0&id=022d4e24&lang=scss&scoped=true"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022d4e24"]])

export default __exports__